import React from 'react';

import classNames from 'classnames';
import Dropdown from 'components/cosmos/dropdown';
import Icon from 'components/icons';
import { ReactComponent as BellCosmos } from 'components/svg/icons/bell-md.svg';
import { ReactComponent as PublishIcon } from 'components/svg/icons/publish.svg';
import { ReactComponent as UploadCosmos } from 'components/svg/icons/upload-md.svg';
import I18n from 'components/translate/I18n';
import PropTypes from 'prop-types';

import PublishAndNotifyButton from './PublishAndNotifyButton';

import './PublishAndNotifyDropdown.scss';

const PublishButton = () => (
  <span className="publish-dropdown__item__title__label _d-flex">
    <I18n label="general.publish" />
  </span>
);

const publishAndNotify = ({
  shouldShowModal,
  openModal,
  onPublishAndNotify
}) => {
  if (shouldShowModal) {
    openModal(onPublishAndNotify);

    return;
  }

  onPublishAndNotify();

  Dropdown.closeMenu();
};

const PublishAndNotifyDropdown = ({
  disable,
  shouldShowModal,
  publishButtonBig,
  openModal,
  onPublish,
  onPublishAndNotify,
  disableNotify
}) => {
  const publishAndClose = () => {
    onPublish();

    Dropdown.closeMenu();
  };

  const options = [
    {
      label: <PublishButton />,
      icon: <UploadCosmos />,
      isDisabled: false,
      onClick: publishAndClose
    },
    {
      label: <PublishAndNotifyButton />,
      icon: <BellCosmos />,
      isDisabled: disableNotify,
      onClick: () =>
        publishAndNotify({ shouldShowModal, openModal, onPublishAndNotify })
    }
  ];

  return (
    <Dropdown className="publish-dropdown">
      {publishButtonBig ? (
        <button
          className="hot-button hot-button--primary hot-button--lg _mt-lg-0"
          data-test="publish-button"
          disabled={disable}
          slot="button"
        >
          <Icon prefix="fal" iconName="arrow-alt-to-top" className="_mr-2" />
          <I18n label="general.publish" />
        </button>
      ) : (
        <button
          className="hot-button hot-button--tertiary"
          data-test="publish-button-small"
          disabled={disable}
          slot="button"
        >
          <PublishIcon
            className={classNames('icon', { '-disabled': disable })}
          />
          <I18n label="general.publish" />
        </button>
      )}
      {options.map((item, index) => (
        <Dropdown.MenuItem
          item={item}
          key={index}
          className={classNames({ 'is-disabled': item.isDisabled })}
          onClick={item.onClick}
        >
          <span className="publish-dropdown__menu-item _d-flex _align-items-center">
            {item.icon}
            <div className="publish-dropdown__item">{item.label}</div>
          </span>
        </Dropdown.MenuItem>
      ))}
    </Dropdown>
  );
};

PublishAndNotifyDropdown.propTypes = {
  disable: PropTypes.bool,
  disableNotify: PropTypes.bool,
  shouldShowModal: PropTypes.bool,
  publishButtonBig: PropTypes.bool,
  openModal: PropTypes.func,
  onPublish: PropTypes.func,
  onPublishAndNotify: PropTypes.func
};

export default PublishAndNotifyDropdown;
